import type { ReactNode } from 'react';

import type { DefinitionComponent } from '../types';
import type { Jurisdiction } from '../types';

interface Props<
  TSection extends DefinitionComponent,
  TFormDefinition extends { sections: Array<TSection> }
> {
  def: TFormDefinition;
  createComponent: (definition: TSection) => ReactNode;
  readOnly: boolean;
  jurisdictions: Array<Jurisdiction>;
}

export const Sections = <
  TSection extends DefinitionComponent,
  TFormDefinition extends { sections: Array<TSection> }
>({
  def,
  createComponent,
  readOnly,
  jurisdictions
}: Props<TSection, TFormDefinition>) => {
  return (
    <>
      {def.sections.map((section) => {
        return (
          <div key={section.code} className="pb-4">
            {createComponent({ ...section, readOnly, jurisdictions })}
          </div>
        );
      })}
    </>
  );
};
